import React, { ReactNode } from 'react'

interface IProps {
  icon?: string,
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  itemRender?: () => ReactNode,
  title?: string,
  secondaryTitle?: string | number,
  className?: string,
  force?: boolean,
  active?: boolean,
  disabled?: boolean,
  price?: number
}

export default function Tabs({ icon, onClick, itemRender, title, secondaryTitle, className, force, active = true, disabled, price }: IProps) {
  return (
    <button className={`flexed p-0 bg-none bd-none iran-sans radius-4 ${(!active ? "op-50" : " ")} ${className}`} disabled={disabled}
      onClick={(e) => active && onClick && onClick(e)}>
      <div className="flexed py-12 pr-16 radius-8 bg-top-nav-70 h-100 w-100 align-c" {...(!force ? { style: { height: 82 } } : {})}>
        {icon && <img src={icon} alt="" className="fit-contain" style={{ width: 38 }} />}
        <div className={"flexed align-c flex-1 p-16 text-right " + ((secondaryTitle || secondaryTitle === 0) && "separator")}>
          {title && <span className="font-12 line-2">{title}</span>}
          {itemRender && <div>{itemRender}</div>}
        </div>
        {(secondaryTitle || secondaryTitle === 0) &&
          (typeof secondaryTitle === "object" ? <>{secondaryTitle}</> :
            <div className="flexed fl-c fdir-col text-center" style={{ minWidth: 60 }}>
              <span className="font-11">{secondaryTitle}</span><span className="font-10">مورد</span></div>)}
        {price !== undefined ? <div className="h-80 flexed fl-c fdir-col px-16" style={{ borderRight: "1px solid #d1d1d1" }}>
          <span>{price !== 0 ? price : "رایگان"}</span>
          {price !== 0 ? <span>تومان</span> : null}
        </div> : null}
      </div>
    </button>
  )
}